export default "__VITE_ASSET__GZIssDmn__"